import React from "react";
import { getDataSource } from "../../services/api";
import { handleImageError } from "../../utils/common";
import DeputyCard from "../Canditates/DeputyCard";

const House = ({ t, data }) => {
  const { logo, partyName, electedToChamber, deputies, translation } = data;
  return (
    <div className="px-0 bg-white pt-10">
      <span className="text-22 font-medium uppercase md:hidden">
        {t("seatsInTheChamber")}
      </span>
      <span className="font-medium text-32 md:block hidden">
        {t("seatsInTheChamber")}
      </span>

      <div className="h-[1px] bg-black bg-opacity-40 mb-7"></div>
      <img
        src={`${getDataSource()}/parties/${logo}-seats.svg`}
        alt={partyName}
        onError={handleImageError}
        className="ml-4 mr-8 md:hidden"
      />
      <div className="pt-10 md:pt-0">
        <span className="text-22 font-medium">
          {partyName}: {electedToChamber} {t("deputies")}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-1 gap-2 items-start mt-3 md:hidden">
        {deputies.map((deputy) => (
          <DeputyCard
            key={deputy.deputyName}
            deputy={deputy}
            t={t}
            party={logo}
            translation={translation}
          />
        ))}
      </div>
      <div className="hidden md:flex">
        <div className="mt-3 w-1/2">
          {deputies.map((deputy) => (
            <DeputyCard
              key={deputy.deputyName}
              deputy={deputy}
              t={t}
              party={logo}
              translation={translation}
            />
          ))}
        </div>
        <div className="bg-wort py-2 ml-5 mt-3 w-1/2">
          <img
            src={`${getDataSource()}/parties/${logo}-seats.svg`}
            alt={partyName}
            onError={handleImageError}
            className="ml-4 mr-8"
          />
        </div>
      </div>
    </div>
  );
};

export default House;
